import type { TableTranslation } from './table-pl';

export const tableEn = {
  of: 'of',
  reset: 'Reset',
  searchPlaceholder: 'Search...',
  savedViews: 'Saved views',
  saveView: 'Save view',
  saveInfo: 'The following will be saved: table settings and applied filters.',
  name: 'Name',
  namePlaceholder: 'e.g. Client orders',
  description: 'Description',
  descriptionPlaceholder: 'Short description of how the filter works',
  setAsDefaultView: 'Set as default view',
  save: 'Save',
  cancel: 'Cancel',
  default: 'Default',
  delete: 'Delete',
  noSavedViews: 'There is no saved views yet',
  noData: 'No data',
  columnsOrder: 'Columns order',
  columnsOrderSettings: 'Columns order settings',
  columnsOrderInfo:
    'Drag to change the order of columns. Hide (eye) or pin (pin) selected elements. Pinned columns are always visible on the left side of the table.',
  columnsOrderInfoBanner: 'Setting is assigned to saved views.',
  overrideCurrentView: 'Override current view',
  overrideCurrentViewModalHeader: 'Override saved view?',
  overrideCurrentViewModalDescription:
    'The table settings have been changed. Do you want to override the view <strong>{{name}}</strong> with the current view?',
  override: 'Override',
  saveAsNewView: 'Save as new view',
  noSearchResults: 'No results. Change the search criteria.',
  moreOptions: 'More options',
  advancedFilters: 'Advanced filters',
  exportToCsv: 'Download CSV',
  csvExportStarted: 'CSV download started',
  csvExportSuccess: 'CSV file has been downloaded successfully',
  csvExportError: 'Failed to download CSV file',
} satisfies TableTranslation;
